/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Footer_viewer = {
    readonly isTradeExperienceEnabled: boolean | null;
    readonly isSellerApplicationEnabled: boolean | null;
    readonly isAboutUsPageEnabled: boolean | null;
    readonly isCareersPageEnabled: boolean | null;
    readonly isPressPageEnabled: boolean | null;
    readonly isQuestionsPageEnabled: boolean | null;
    readonly isSiteMapsEnabled: boolean | null;
    readonly disableFooterSubscribe: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"CurrencySelector_viewer" | "FooterBottomRow_viewer" | "ConnectRow_viewer" | "FooterSubscribe_viewer">;
    readonly " $refType": "Footer_viewer";
};
export type Footer_viewer$data = Footer_viewer;
export type Footer_viewer$key = {
    readonly " $data"?: Footer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"Footer_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Footer_viewer",
  "selections": [
    {
      "alias": "isTradeExperienceEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "TRADE_EXPERIENCE"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"TRADE_EXPERIENCE\")"
    },
    {
      "alias": "isSellerApplicationEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "SELLER_APPLICATION"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"SELLER_APPLICATION\")"
    },
    {
      "alias": "isAboutUsPageEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "ABOUT_US_PAGE"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"ABOUT_US_PAGE\")"
    },
    {
      "alias": "isCareersPageEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "CAREERS_PAGE"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"CAREERS_PAGE\")"
    },
    {
      "alias": "isPressPageEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "PRESS_PAGE"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"PRESS_PAGE\")"
    },
    {
      "alias": "isQuestionsPageEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "QUESTIONS_PAGE"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"QUESTIONS_PAGE\")"
    },
    {
      "alias": "isSiteMapsEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "HTML_SITE_MAPS"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale(featureName:\"HTML_SITE_MAPS\")"
    },
    {
      "alias": "disableFooterSubscribe",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "disableFooterSubscribe"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabled",
      "storageKey": "isEnabled(key:\"disableFooterSubscribe\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CurrencySelector_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FooterBottomRow_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ConnectRow_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FooterSubscribe_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '0409cf920759365e085a6824a574a4de';
export default node;
